import React from 'react';
import PropTypes from 'prop-types';

// Components
import WidgetDescription from './WidgetDescription';
import WidgetHelper from './WidgetHelper';

// Presentational Component
const WidgetEvent = ({ event }) => {
	return (
		<tr>
			<td>
				{event.name}
				{event.isPreventable &&
					<div>
						<em>preventable</em>
					</div>
				}
			</td>
			<td className='wrap-me'>
				<WidgetDescription desc={event.summary} />
				{event.helper &&
					<WidgetHelper helperName={event.helper} />
				}
			</td>
		</tr>
	);
};

WidgetEvent.propTypes = {
	event: PropTypes.object.isRequired
};

export default WidgetEvent;



// WEBPACK FOOTER //
// ./src/components/widgets/WidgetEvent.js